<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12" md="12">
                <component-header
                    title="Edit Blog"
                    :hasSearch="false"
                    :hasCreate="false"
                    :hasReload="false"
                    :hasback="true"
                    @back-press="$router.push('/channels/contentManagement')"
                />
            </b-col>
            <b-col cols="12" md="12">
                <b-card>
                    <ValidationObserver v-slot="{ invalid }" ref="observer">
                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Title *</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="title"
                                >
                                    <b-form-input
                                        class="custom-transform-class"
                                        inputType="text"
                                        placeholder="Blog Title"
                                        v-model="formData.title"
                                    />
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>

                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Excerpt *</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="excerpt"
                                >
                                    <b-form-textarea
                                        v-model="formData.excerpt"
                                        placeholder="Enter blog excerpt..."
                                        rows="3"
                                        max-rows="6"
                                    ></b-form-textarea>
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>

                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Author *</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="author"
                                >
                                    <b-form-input
                                        class="custom-transform-class"
                                        inputType="text"
                                        placeholder="Author Name"
                                        v-model="formData.author"
                                    />
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>

                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Publish Date *</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="publishDate"
                                >
                                    <b-form-input
                                        type="date"
                                        v-model="formData.publishDate"
                                    ></b-form-input>
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>

                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Featured Image</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="7"
                                class="mb-3 mb-md-0"
                            >
                                <b-form-file
                                    id="featuredImagePicker"
                                    @change="changeFeaturedImage"
                                    :state="Boolean()"
                                    accept="image/*"
                                    placeholder="Choose an image..."
                                    drop-placeholder="Drop image here..."
                                ></b-form-file>
                                <span
                                    v-if="invalidImageFile"
                                    class="validate-error"
                                    >Invalid image format. Please select a valid
                                    image file.</span
                                >
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="1"
                                v-if="uploadingImage"
                                class="mb-3 mb-md-0"
                            >
                                <div
                                    class="spinner-border text-primary"
                                    role="status"
                                ></div>
                            </b-col>
                        </b-row>
                        <b-row
                            v-if="formData.media && formData.media.length"
                            class="form-row"
                        >
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            ></b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <div
                                    v-for="(m, idx) in formData.media"
                                    :key="idx"
                                    class="image-preview-container"
                                    style="margin-bottom: 1rem"
                                >
                                    <img
                                        :src="m.value || m"
                                        :alt="`Media Preview ${idx + 1}`"
                                        class="featured-image-preview"
                                    />
                                    <b-button
                                        size="sm"
                                        variant="danger"
                                        @click="removeMedia(idx)"
                                        class="remove-image-btn"
                                    >
                                        <i class="fa fa-times"></i> Remove
                                    </b-button>
                                </div>
                            </b-col>
                        </b-row>

                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Content *</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="content"
                                >
                                    <vue-editor
                                        v-model="formData.content"
                                    ></vue-editor>
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>

                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">SEO Title</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <b-form-input
                                    class="custom-transform-class"
                                    inputType="text"
                                    placeholder="SEO Title"
                                    v-model="formData.seoTitle"
                                />
                            </b-col>
                        </b-row>

                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">SEO Description</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <b-form-textarea
                                    v-model="formData.seoDescription"
                                    placeholder="Enter SEO description..."
                                    rows="3"
                                    max-rows="6"
                                ></b-form-textarea>
                            </b-col>
                        </b-row>

                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Tags</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <div class="tags-input-container">
                                    <b-input-group>
                                        <b-form-input
                                            v-model="tagInput"
                                            placeholder="Enter tags (press Enter or comma to add)"
                                            @keyup.enter="addTag"
                                            @keyup="handleTagInput"
                                            class="tag-input"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-button
                                                variant="primary"
                                                @click="addTag"
                                            >
                                                <i class="fas fa-plus"></i> Add
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <div
                                        v-if="
                                            formData.tags &&
                                            formData.tags.length > 0
                                        "
                                        class="tags-display mt-2"
                                    >
                                        <b-badge
                                            v-for="(
                                                tag, index
                                            ) in formData.tags"
                                            :key="index"
                                            variant="secondary"
                                            class="tag-badge mr-2 mb-2"
                                        >
                                            {{ tag }}
                                            <i
                                                class="fas fa-times ml-1 tag-remove"
                                                @click="removeTag(index)"
                                            ></i>
                                        </b-badge>
                                    </div>
                                    <small class="form-text text-muted mt-1">
                                        Enter tags separated by commas or press
                                        Enter to add
                                    </small>
                                </div>
                            </b-col>
                        </b-row>

                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Status *</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="status"
                                >
                                    <b-form-select
                                        v-model="formData.status"
                                        :options="statusOptions"
                                    ></b-form-select>
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>

                        <hr />
                        <div class="text-center mt-3 mb-3">
                            <eb-button
                                class="btn mr-4 fixed-width-btn"
                                classic="mr-1 btn-primary"
                                text="Update"
                                :disabled="invalid || showLoader"
                                @click.prevent="handleSubmit"
                            ></eb-button>
                            <eb-button
                                class="btn fixed-width-btn"
                                classic="mr-1 btn-secondary"
                                text="Cancel"
                                @click.prevent="cancel"
                            ></eb-button>
                        </div>
                    </ValidationObserver>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import ebButton from "@/components/FormElements/Button";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ComponentHeader from "@/components/componentNewHeader";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
    name: "EditBlog",
    components: {
        VueEditor,
        ebButton,
        ValidationObserver,
        ValidationProvider,
        ComponentHeader,
    },
    data: () => {
        return {
            showLoader: false,
            uploadingImage: false,
            invalidImageFile: false,
            blogId: null,
            formData: {
                title: "",
                excerpt: "",
                author: "",
                publishDate: "",
                media: [],
                content: "",
                seoTitle: "",
                seoDescription: "",
                tags: [],
                status: 0,
            },
            tagInput: "",
            statusOptions: [
                { value: 0, text: "Draft" },
                { value: 1, text: "Pending" },
                { value: 2, text: "Published" },
            ],
        };
    },
    computed: {
        ...mapGetters({
            BlogData: "blog/GetBlogData",
        }),
    },
    methods: {
        changeFeaturedImage(e) {
            const file = e.target.files[0];
            if (!file) return;

            // Validate file type
            if (!file.type.match("image.*")) {
                this.invalidImageFile = true;
                e.target.value = "";
                return;
            }

            this.invalidImageFile = false;

            // Read file as data URL for preview and upload
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.uploadImage(reader.result);
            };
            reader.onerror = (err) => {
                console.error("File reader error:", err);
                this.$toasted.error("Failed to read image file");
            };
        },
        async uploadImage(imageData) {
            this.uploadingImage = true;
            this.$toasted.info("Uploading image...");

            const dataobj = {
                image: imageData,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: "blog",
            };

            try {
                const res = await this.$store.dispatch(
                    "inventory/uploadImageToStorage",
                    dataobj,
                );
                if (res && res.data) {
                    const url = res.data.fileUrl || res.data;
                    this.formData.media = this.formData.media || [];
                    this.formData.media.push({ type: "IMAGE", value: url });
                    this.$toasted.success("Image uploaded successfully!");
                }
            } catch (error) {
                this.$toasted.error("Image upload failed! Please try again.");
                this.formData.media = [];
            } finally {
                this.uploadingImage = false;
            }
        },
        removeFeaturedImage() {
            this.formData.media = [];
            const fileInput = document.getElementById("featuredImagePicker");
            if (fileInput) {
                fileInput.value = "";
            }
        },
        removeMedia(index) {
            if (!Array.isArray(this.formData.media)) this.formData.media = [];
            this.formData.media.splice(index, 1);
            const fileInput = document.getElementById("featuredImagePicker");
            if (fileInput) {
                fileInput.value = "";
            }
        },
        handleTagInput(event) {
            if (event.key === "," || event.keyCode === 188) {
                event.preventDefault();
                this.addTag();
            }
        },
        addTag() {
            if (!this.tagInput || !this.tagInput.trim()) return;

            const tags = this.tagInput
                .split(",")
                .map((tag) => tag.trim())
                .filter((tag) => tag.length > 0);

            if (!this.formData.tags) {
                this.formData.tags = [];
            }

            tags.forEach((tag) => {
                if (!this.formData.tags.includes(tag)) {
                    this.formData.tags.push(tag);
                }
            });

            this.tagInput = "";
        },
        removeTag(index) {
            if (this.formData.tags && Array.isArray(this.formData.tags)) {
                this.formData.tags.splice(index, 1);
            }
        },
        async loadBlogData() {
            this.showLoader = true;
            try {
                await this.$store.dispatch("blog/fetchBlogById", this.blogId);
                const blog = this.BlogData;
                if (blog) {
                    // normalize media: use blog.media if present, otherwise fall back to featuredImage
                    let mediaArr = [];
                    if (Array.isArray(blog.media) && blog.media.length) {
                        mediaArr = blog.media.map((m) =>
                            typeof m === "string"
                                ? { type: "IMAGE", value: m }
                                : m,
                        );
                    } else if (blog.featuredImage) {
                        mediaArr = [
                            { type: "IMAGE", value: blog.featuredImage },
                        ];
                    }

                    // Handle meta.extraDetails structure or fallback to direct properties
                    const extraDetails = blog.meta?.extraDetails || {};
                    const publishDate =
                        extraDetails.publishDate || blog.publishDate;
                    const excerpt = extraDetails.excerpt || blog.excerpt || "";
                    const seoTitle =
                        extraDetails.seoTitle || blog.seoTitle || "";
                    const seoDescription =
                        extraDetails.seoDescription ||
                        blog.seoDescription ||
                        "";
                    const tags = extraDetails.tags || blog.tags || [];

                    // Handle status: convert string to number if needed, or use number directly
                    let status = blog.status;
                    if (typeof status === "string") {
                        if (status === "draft") status = 0;
                        else if (status === "pending") status = 1;
                        else if (status === "published") status = 2;
                        else status = 0;
                    } else if (typeof status !== "number") {
                        status = 0;
                    }

                    this.formData = {
                        title: blog.title || "",
                        excerpt: excerpt,
                        author: blog.meta.extraDetails.author || "",
                        publishDate: publishDate
                            ? moment(publishDate).format("YYYY-MM-DD")
                            : "",
                        media: mediaArr,
                        content: blog.content || "",
                        seoTitle: seoTitle,
                        seoDescription: seoDescription,
                        tags: Array.isArray(tags) ? tags : [],
                        status: status,
                    };
                }
            } catch (error) {
                this.$swal({
                    title: "Error",
                    text: "Failed to load blog data. Please try again.",
                    type: "error",
                });
                this.$router.push('/channels/contentManagement');
            } finally {
                this.showLoader = false;
            }
        },
        async handleSubmit() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;

            this.showLoader = true;
            try {
                const userId = this.$currentUserData
                    ? this.$currentUserData._id
                    : this.$store.getters["auth/getUserID"];
                const userName = this.$currentUserData
                    ? this.$currentUserData.userName
                    : this.$store.getters["auth/getUserName"] || "";

                const payload = {
                    title: this.formData.title,
                    media: this.formData.media || [],
                    content: this.formData.content,
                    status: this.formData.status,
                    meta: {
                        extraDetails: {
                            author: this.formData.author,
                            publishDate: this.formData.publishDate,
                            excerpt: this.formData.excerpt,
                            seoTitle: this.formData.seoTitle,
                            seoDescription: this.formData.seoDescription,
                            tags: this.formData.tags || [],
                        },
                    },
                    user: {
                        _id: userId,
                        name: userName,
                    },
                };

                await this.$store.dispatch("blog/updateBlog", {
                    id: this.blogId,
                    data: payload,
                });
                this.$swal({
                    title: "Success",
                    text: "Blog updated successfully!!",
                    type: "success",
                });
                this.$store.dispatch("blog/fetchBlogsList");
                this.$router.push('/channels/contentManagement');
            } catch (error) {
                this.$swal({
                    title: "Error",
                    text: "Failed to update blog. Please try again.",
                    type: "error",
                });
            } finally {
                this.showLoader = false;
            }
        },
        cancel() {
            this.$router.push('/channels/contentManagement');
        },
    },
    mounted() {
        this.blogId = this.$route.params.id;
        if (this.blogId) {
            this.loadBlogData();
        } else {
            this.$router.push('/channels/contentManagement');
        }
    },
};
</script>

<style scoped>
.form-row {
    margin-bottom: 1rem;
}

.form-label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
}

.validate-error {
    display: block;
    color: red;
    font-size: 12px;
    margin-top: 5px;
}

.fixed-width-btn {
    width: 100px;
    font-size: 15px;
}

.image-preview-container {
    margin-top: 1rem;
    position: relative;
    display: inline-block;
}

.featured-image-preview {
    max-width: 300px;
    max-height: 200px;
    border-radius: 4px;
    border: 1px solid #ddd;
    display: block;
    margin-bottom: 0.5rem;
}

.remove-image-btn {
    margin-top: 0.5rem;
}

.tags-input-container {
    width: 100%;
}

.tag-input {
    border-radius: 6px;
}

.tags-display {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.tag-badge {
    font-size: 0.875rem;
    padding: 0.375rem 0.75rem;
    cursor: default;
    display: inline-flex;
    align-items: center;
}

.tag-remove {
    cursor: pointer;
    margin-left: 0.5rem;
}

.tag-remove:hover {
    color: #fff;
    opacity: 0.8;
}

@media (max-width: 767.98px) {
    .form-label {
        margin-bottom: 0.25rem;
        font-size: 0.9rem;
    }

    .fixed-width-btn {
        width: 100%;
        margin-bottom: 0.5rem;
    }

    .featured-image-preview {
        max-width: 100%;
    }
}
</style>
